/*
 * @Author: shiguang
 * @Date: 2024-04-19 15:24:36
 * @LastEditors: yusha
 * @LastEditTime: 2024-06-07 14:29:02
 * @Description:
 */
const REACT_APP_ENV = process.env.REACT_APP_ENV;

interface ProcessDifferentEnvParams<T> {
	test: T;
	pre: T;
	prod: T;
	projectCode?: T;
}

export const processDifferentEnv = <T extends (...params: any[]) => any>(
	params: ProcessDifferentEnvParams<T>
) => {
	if (REACT_APP_ENV === 'test') {
		return params.test();
	}
	if (REACT_APP_ENV === 'pre') {
		return params.pre();
	}
	if (REACT_APP_ENV === 'prod') {
		return params.prod();
	}
	return params.prod();
};
const userAgent = window.navigator.userAgent;
// android终端
const isAndroid =
	userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1;
// ios终端
const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

interface processDifferentOperationSystemParams<T> {
	ios: T;
	android: T;
	other?: T;
}
export const processDifferentOperationSystem = <
	T extends (...params: any[]) => any
>(
	params: processDifferentOperationSystemParams<T>
) => {
	if (isIOS) {
		return params.ios();
	}
	if (isAndroid) {
		return params.android();
	}
	if (params.other) {
		return params.other();
	}
	return params.ios();
};
